import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLead } from "../../redux/leads/lead.slices";
// import CreditCardFormAuthorizenet from "../../components/CreditCardFormAuthorizenet";
import AchFormAuthorizenet from "../../components/AchFormAuthorizenet";
import CreditCardForm from "../../components/CreditCardStripeElement";
// import AchForm from "../../components/AchForm";
import SelectMethodBtn from "../../components/SelectMethodBtn";
import useProratedCharges from "../../hooks/useProratedCharges";
import ReCAPTCHA from "react-google-recaptcha";

export default function PaymentHome() {
  const [selectedOption, setSelectedOption] = useState("credit");
  const [initialAmountCharged, setInitialAmountCharged] = useState(0);
  const [captchaValue, setCaptchaValue] = useState(null);

  const dispatch = useDispatch();
  const { id } = useParams();

  const { isLoading, lead } = useSelector((state) => state.leads);

  useEffect(() => {
    dispatch(getLead(id));
  }, [dispatch, id]);

  // const totalOnetimeFees = lead?.onetime_fees?.reduce(
  //   (acc, curr) => (acc += parseFloat(curr?.feeAmount)),
  //   0
  // );

  const { proratedCharges, totalCharges } = useProratedCharges(lead);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const renderPaymentForm = () => {
    const method = lead?.paymentMethod;

    const CardForm = CreditCardForm;
    const BankForm = AchFormAuthorizenet;

    if (method === "both") {
      return (
        <div className="p-6 flex flex-col justify-center">
          <div className="flex flex-col rounded-md w-full p-6 mx-auto lg:w-2/3 gap-2 sm:flex-row">
            <SelectMethodBtn
              text={"Credit or Debit Card"}
              selectedOption={selectedOption}
              onSelectedOption={() => setSelectedOption("credit")}
              icon="ri-bank-card-2-line"
              title="credit"
            />
            <SelectMethodBtn
              text={"ACH (Bank Account)"}
              selectedOption={selectedOption}
              onSelectedOption={() => setSelectedOption("ACH")}
              icon="ri-bank-line"
              title="ACH"
            />
          </div>
          {selectedOption === "ACH" ? (
            <BankForm
              lead={lead}
              prorated={proratedCharges}
              captchaValue={captchaValue}
              previousChargedAmount={initialAmountCharged}
            />
          ) : (
            <CardForm
              lead={lead}
              onSelectedOption={(amount) => {
                if (amount !== undefined) {
                  setInitialAmountCharged(amount);
                }
                setSelectedOption("ACH");
              }}
              prorated={proratedCharges}
              captchaValue={captchaValue}
            />
          )}
        </div>
      );
    }

    if (method === "ach") {
      return (
        <div>
          <h2 className="text-center text-2xl my-6">
            Enter your bank account details
          </h2>
          <p className="text-center text-gray-500 text-sm px-6">
            Your bank details will be securely processed for ACH payments
          </p>
          <BankForm
            lead={lead}
            prorated={proratedCharges}
            captchaValue={captchaValue}
          />
        </div>
      );
    }

    // Default: card only
    return (
      <div>
        <h2 className="text-center text-2xl my-6">
          Provide your credit card details
        </h2>
        <CardForm
          lead={lead}
          prorated={proratedCharges}
          captchaValue={captchaValue}
        />
      </div>
    );
  };

  return (
    <>
      <section className="border min-h-1/2 w-screen rounded-md lg:w-1/2 mx-auto m-10">
        <div className="py-6 flex flex-col justify-center items-center rounded-t-md bg-gradient-to-r from-[#021521] to-[#083757]">
          <h1 className="text-white text-center text-xl px-4">
            Complete Payment
          </h1>
          <p className="text-gray-500 mt-4">
            Package Name:{" "}
            <span className="text-yellow-400">{lead?.package?.name}</span>
          </p>
          <p className="text-gray-500">
            Package Amount:{" "}
            <span className="text-white">
              ${lead?.package?.amount?.toFixed(2)}
            </span>
          </p>
          <p className="text-gray-500">
            Subtotal: <span className="text-white">${totalCharges.toFixed(2)}</span>
          </p>
          <hr className="my-2 text-yellow-400 w-1/2" />
          <p className="text-gray-500">
            Tax (8.25%):{" "}
            <span className="text-white">
              ${(totalCharges * 0.0825).toFixed(2)}
            </span>
          </p>
          <hr className="my-2 text-yellow-400 w-1/2" />
          <p className="text-red-500">
            Total Due Today:{" "}
            <span className="text-white">
              ${(totalCharges * 1.0825).toFixed(2)}
            </span>
          </p>
        </div>
        {isLoading ? (
          <div className="p-6 flex items-center justify-center">
            <div className="text-black">Loading...</div>
          </div>
        ) : (
          <div>
            <div className="p-6 flex flex-col justify-center items-center">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
                onChange={handleCaptchaChange}
              />
              {captchaValue ? (
                <p className="text-green-500">Captcha verified</p>
              ) : (
                <p className="text-red-500">Please complete the captcha</p>
              )}
            </div>
            {renderPaymentForm()}
          </div>
        )}
      </section>
    </>
  );
}
